import { createContext, useContext } from 'react'

import type { ClientSession, Membership } from './session'

export interface PortalContext {
  session: ClientSession
  /** The customer the portal is currently working in. */
  membership: Membership
  selectCustomer: (customerId: string) => void
}

/**
 * In its own module so the provider file exports only components: mixing the
 * two defeats React Fast Refresh.
 */
export const PortalContextValue = createContext<PortalContext | null>(null)

export function usePortal(): PortalContext {
  const value = useContext(PortalContextValue)
  if (!value) {
    throw new Error('usePortal was called outside an authenticated tree.')
  }
  return value
}
